import url from './urls'

const state = {
  categories: [],
  archives: [],
  isLoading: false
}

const mutations = {
  GETCATEGORY (state) {
    state.categories = []
    state.isLoading = true

    fetch(url.program.category)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.categories = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  },

  GETARCHIVES (state, idAndYear) {
    state.archives = []
    state.isLoading = true

    fetch(`${url.program.archive}?category=${idAndYear.id}&year=${idAndYear.year}`)
      .then(response => response.json())
      .then(data => {
        state.isLoading = false
        state.archives = data
      })
      .catch(err => {
        state.isLoading = false
        console.error(err)
      })
  }
}

const actions = {
  getCategory ({ commit }) {
    commit('GETCATEGORY')
  },

  getArchives ({ commit }, idAndYear) {
    commit('GETARCHIVES', idAndYear)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
